import axios from 'axios';
import apiUrl from './apiUrl';

// Caso ocorra algum erro no servidor (de teste ou de produção), o erro pode ser a falta da
// url completa no lugar do /api

export default () => {
  return axios.create({
    baseURL: apiUrl,
  });
};
